import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { SplitpaneStyle } from './Splitpane.style';
import ArrowLeftIcon from '@material-ui/icons/ArrowBackIosRounded';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  something:boolean;
}

interface IProps extends WithStyles<typeof SplitpaneStyle> {
  moveStart:(screenY:number) => void;
  moveMove:(screenY:number) => void;
  moveEnd:() => void;
  inEditMode:boolean;
  paneRef: React.RefObject<HTMLDivElement>;
}

class SplitPane extends React.Component<IProps, IState> {
  private isMouseDragging:boolean = false;

  constructor(props: IProps) {
    super(props);
    
    this.moveStart = this.moveStart.bind(this);
    this.moveMove = this.moveMove.bind(this);
    this.moveEnd = this.moveEnd.bind(this);

    this.state = {
      something:true,
    };

  }

  public componentWillUnmount(): void {
    this.detachMouseHandlers();
  }

  public render() {
    const {classes} = this.props;

    return (
      <div ref={this.props.paneRef} className={classes.splitpane}
        style={this.props.inEditMode?{opacity:0, pointerEvents:'none'}:{}}>
        <div className={classes.drawer} id="split-pane"
          style={{cursor:'ns-resize'}}
          onTouchStart={(e) => this.moveStart(e)}
          onTouchMove={(e) => this.moveMove(e)}
          onTouchEnd={(e) => this.moveEnd(e)}
          onTouchCancel={(e) => this.moveEnd(e)}
          onMouseDown={this.handleMouseDown}
          onClick={() => {return;}}
        >
          <div  className={classes.marker} />
        </div>
        {this.props.children}
      </div>
    );
  }

  private moveStart(e:React.TouchEvent<HTMLDivElement>) {
    e.stopPropagation();
    this.props.moveStart(e.touches[0].screenY);
  }
  private moveMove(e:React.TouchEvent<HTMLDivElement>) {
    e.stopPropagation();
    this.props.moveMove(e.touches[0].screenY);
  }
  private moveEnd(e:React.TouchEvent<HTMLDivElement>) {
    e.stopPropagation();
    this.props.moveEnd();
  }

  private handleMouseDown = (e:React.MouseEvent<HTMLDivElement>) => {
    if (e.button !== 0) {
      return;
    }
    e.stopPropagation();
    this.isMouseDragging = true;
    this.props.moveStart(e.screenY);
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mouseup', this.handleMouseUp);
    window.addEventListener('blur', this.handleMouseCancel);
  };

  private handleMouseMove = (e:MouseEvent) => {
    if (!this.isMouseDragging) {
      return;
    }
    this.props.moveMove(e.screenY);
  };

  private handleMouseUp = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.props.moveEnd();
    this.detachMouseHandlers();
  };

  private handleMouseCancel = () => {
    if (!this.isMouseDragging) {
      return;
    }
    this.isMouseDragging = false;
    this.props.moveEnd();
    this.detachMouseHandlers();
  };

  private detachMouseHandlers() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('mouseup', this.handleMouseUp);
    window.removeEventListener('blur', this.handleMouseCancel);
  }
}


export default withStyles(SplitpaneStyle)(SplitPane);



// WEBPACK FOOTER //
// ./src/components/calendar2/splitpane/Splitpane.tsx